import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const EqualOpportunitiesDiversityPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  diversityOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Equal_Opportunities_and_Diversity_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Equal Opportunities and Diversity Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to promoting equality, diversity, and inclusion throughout its workforce, ensuring that all employees and job applicants are treated fairly and without discrimination.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all aspects of employment including recruitment, training, promotion, remuneration, and termination, as well as to interactions with clients, suppliers, and the public.
      </p>

      <h4 className="section-title">3. Our Commitment</h4>
      <ul>
        <li>We will comply fully with the Equality Act 2010 and all relevant legislation relating to discrimination.</li>
        <li>We will promote a workplace culture that respects and values individual differences including age, disability, gender reassignment, marriage and civil partnership, pregnancy and maternity, race, religion or belief, sex, and sexual orientation.</li>
        <li>We will take positive action to eliminate discrimination, harassment, and victimisation.</li>
        <li>We will encourage employees to challenge discriminatory behaviour and support those who raise concerns.</li>
      </ul>

      <h4 className="section-title">4. Responsibilities</h4>
      <p className="section-content"><strong>Management:</strong> Ensure this policy is implemented effectively and lead by example.</p>
      <p className="section-content"><strong>Employees:</strong> Treat colleagues with respect and adhere to this policy in all workplace interactions.</p>
      <p className="section-content"><strong>HR and Diversity Officer:</strong> Monitor compliance, provide training, and support diversity initiatives.</p>

      <h4 className="section-title">5. Recruitment and Selection</h4>
      <p className="section-content">
        Recruitment practices will be designed to attract a diverse pool of candidates and selection decisions will be based solely on merit, skills, and abilities.
      </p>

      <h4 className="section-title">6. Training and Development</h4>
      <p className="section-content">
        {clientName || "The Company"} will provide regular training to raise awareness of equality and diversity issues and to promote inclusive behaviours.
      </p>

      <h4 className="section-title">7. Reporting and Handling Discrimination</h4>
      <p className="section-content">
        Any employee who believes they have been subjected to discrimination, harassment, or victimisation is encouraged to report the matter promptly through the grievance procedure.
      </p>

      <h4 className="section-title">8. Monitoring and Review</h4>
      <p className="section-content">
        The company will monitor the effectiveness of this policy and review it annually to ensure continuous improvement and compliance with legislation.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <ul>
        <li><strong>HR Department:</strong> {hrContact || "[Insert Contact Number]"}</li>
        <li><strong>Diversity Officer:</strong> {diversityOfficerContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to abide by the Equal Opportunities and Diversity Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default EqualOpportunitiesDiversityPolicy;
